import { FC, useEffect, useMemo } from 'react';
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';

import { Divider, Tab } from '@mui/material';

import { Tabs } from '@/components/Tabs';
import { useAgencyStore, useDataStore } from '@/store';

import { UnitManagementTabs } from './data';

export const UnitManagement: FC = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { agencyId } = useParams();
  const { agencies, currentAgency, fetchAgency } = useAgencyStore();
  const { fetchUnitTypes } = useDataStore();

  const paths = pathname.split('/');

  const userManagementTabs = useMemo(() => {
    const tabs = { ...UnitManagementTabs };
    return Object.values(tabs);
  }, [currentAgency]);

  useEffect(() => {
    if (agencyId) {
      fetchAgency(agencyId);
    }
  }, [agencyId]);

  useEffect(() => {
    if (!currentAgency && agencyId) {
      fetchAgency(agencyId);
    }
  }, [agencies.length, agencyId]);

  useEffect(() => {
    if (agencyId) {
      fetchUnitTypes(agencyId);
    }
  }, [agencyId, fetchUnitTypes]);

  return (
    <>
      <Tabs
        value={paths[4]}
        onChange={(_e, newValue: string) => navigate(newValue)}
      >
        {userManagementTabs.map(({ path, label }) => (
          <Tab key={path} label={label} value={path} />
        ))}
      </Tabs>
      <Divider />
      <Outlet />
    </>
  );
};
